import Tooltip from "@material-ui/core/Tooltip";
import React, { FC, useState } from "react";

import Button from "../../../../../components/elements/Button";
import EditCampaignDetailsModal from "./EditCampaignDetailsModal";
import EditCampaignDetailsModalRedesign from "./EditCampaignDetailsModalRedesign";
import PrimaryButton from "../../../../../components/redesign/elements/Button/PrimaryButton";
import { BrandgenCampaignPool } from "../../../../../types/campaignTypes";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

type EditCampaignDetailsButtonProps = {
  campaignToEdit: BrandgenCampaignPool;
  fetchAndSetCampaings: () => void;
};

const EditCampaignDetailsButton: FC<EditCampaignDetailsButtonProps> = ({ campaignToEdit, fetchAndSetCampaings }) => {
  const [isEditCampaignModalOpen, setIsEditCampaignModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsEditCampaignModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditCampaignModalOpen(false);
  };

  const EditCampaignDetailsModalComponent = useNewDesign ? EditCampaignDetailsModalRedesign : EditCampaignDetailsModal;
  const isProcessing = campaignToEdit.status === "processing";

  return (
    <>
      <Tooltip title={isProcessing ? "Campaign is still being created" : ""}>
        <span>
          {useNewDesign ? (
            <PrimaryButton onClick={handleOpenModal} disabled={isProcessing}>
              Edit Campaign Details
            </PrimaryButton>
          ) : (
            <Button onClick={handleOpenModal} variant="contained" disabled={isProcessing}>
              Edit Campaign Details
            </Button>
          )}
        </span>
      </Tooltip>
      <EditCampaignDetailsModalComponent
        isOpen={isEditCampaignModalOpen}
        handleClose={handleCloseModal}
        campaignToEdit={campaignToEdit}
        fetchAndSetCampaings={fetchAndSetCampaings}
      />
    </>
  );
};

export default EditCampaignDetailsButton;
